// Build a rich descriptive section per destination, blending category-templates with
// destination-specific data so all 80 places have unique, contextual content.

const CATEGORY_ACTIVITIES = {
  travel: [
    "Wander historic old-town streets at sunset",
    "Eat at family-run trattorias and hidden bistros",
    "Take a day-trip to a nearby coastal village",
    "Browse local markets for ceramics, linen and produce",
    "Catch a sunset from a famous viewpoint",
    "Spend a slow afternoon in a museum or cathedral",
  ],
  yoga: [
    "Twice-daily asana and pranayama sessions",
    "Guided meditation and breathwork mornings",
    "Plant-based farm-to-table cuisine",
    "Forest bathing or coastal silent walks",
    "Optional one-to-one coaching with the lead teacher",
    "Sound healing or cacao ceremony evenings",
  ],
  wellness: [
    "Spa rituals — hammam, sauna, cold plunge",
    "Beach-club day passes with DJ sets",
    "Champagne brunches and rooftop sunsets",
    "Massage and signature wellness treatments",
    "Late-night dancing at iconic local venues",
    "Pilates or stretch sessions to recover the morning after",
  ],
  adventure: [
    "Guided hiking with a certified local mountain leader",
    "Optional summit attempt for fitter travellers",
    "Wildlife and landscape photography stops",
    "Refuge / mountain-hut overnight stays",
    "Glacier crossings, ridge walks or sea-cliff scrambles",
    "Cold-water swims and post-hike sauna",
  ],
};

const CATEGORY_GROUP_FIT = {
  travel: {
    solo: "Excellent for solo travel — small enough to feel safe walking at night, café culture makes it easy to meet other travellers, and English is widely spoken.",
    couples: "A classic romantic European break — book a heritage hotel and plan a long evening walk.",
    friends: "Ideal for 4–6 friends sharing a townhouse rental and splitting a private boat day.",
    family: "Family-friendly with gelato stops, easy public transport and child-safe historic centres.",
  },
  yoga: {
    solo: "Built around solo travellers — retreat centres pair single travellers in twin rooms or offer private studios, and group meals plus shared practice quickly create real connection.",
    couples: "Couples can take twin sessions side by side and unwind in private suites between practice.",
    friends: "Great as a friends-trio reset — book adjoining rooms and share post-yoga walks.",
    family: "Best for adults; many retreats are 18+ only — check before booking with kids.",
  },
  wellness: {
    solo: "Solo travellers thrive here — beach clubs and day-spas welcome single guests, hotel concierges arrange friendly group activities, and city walking distances make it easy.",
    couples: "Perfect for couples — pair a spa day with a private cabana and a late dinner reservation.",
    friends: "Made for friend groups of 4–8 — pool day, sunset dinner, club night, repeat.",
    family: "Family-friendly resort options exist; nightlife zones are clearly separate from family zones.",
  },
  adventure: {
    solo: "Strongly recommended for solo travellers — guided group tours mean instant company and qualified safety cover, and most operators offer single-supplement-free shared rooms.",
    couples: "Plenty of two-person guided departures; great for couples who like a shared physical challenge.",
    friends: "Brilliant for active friend groups — book a private guide and customise the route.",
    family: "Mixed — some routes are family-suitable (lower-altitude hikes), others are advanced only.",
  },
};

const beautyLine = (parent) => {
  const c = parent.country;
  const t = parent.title;
  const bits = {
    travel:    `${t} is one of Europe's most photogenic corners — a place where light, architecture and food all conspire to slow you down. ${parent.blurb}`,
    yoga:      `Set against the calm of ${c}, ${t} blends serious practice with deep restoration. ${parent.blurb}`,
    wellness:  `${t} delivers the cocktail Europe is famous for — restorative mornings, golden afternoons, electric nights. ${parent.blurb}`,
    adventure: `Raw, scenic and slightly humbling — ${t} is European wilderness at its most rewarding. ${parent.blurb}`,
  };
  return bits[parent.category] || parent.blurb;
};

export function getEscapeNarrative(parent) {
  return {
    beauty:    beautyLine(parent),
    whyAmazing: `Going to ${parent.title} is amazing because you get the rare combination of striking landscapes, a deeply local culture, and the ease of European travel — short transfers, safe streets, and a partner network (${parent.partner}) that can put a complete trip together for you in minutes.`,
    activities: CATEGORY_ACTIVITIES[parent.category] || CATEGORY_ACTIVITIES.travel,
    groupFit:  CATEGORY_GROUP_FIT[parent.category] || CATEGORY_GROUP_FIT.travel,
  };
}
